import { ComplexValue } from 'app/types-shared';
import { Filter, CustomFilterType, FilterType, FilterCommonValues, PredefinedFilterType,
  PredefinedFilter } from 'app/area/search-filters/filters/types';
import { TextConfigurationTranslation } from '../constants';
import { endpoints } from '../endpoints';
import { queryFilters, filterId, fieldType, predefinedFiltersId } from './text/constants';
import { FilterCommonTypes } from 'app/area/search-filters/types-store';
import { getFieldId } from 'app/area/search-filters/filters/selectors';

export const textQueryFilters = (translation: TextConfigurationTranslation): ComplexValue<string>[] => [
  { value: queryFilters.text, description: translation.text },
  { value: queryFilters.originalText, description: translation.original_text }
];

export const predefinedFilters = (translation: TextConfigurationTranslation): PredefinedFilter => ({
  type: PredefinedFilterType.code,
  values: [
    { value: predefinedFiltersId.potentiallyUntranslated, description: translation.potentially_untranslated }
  ]
});

export const textFilters = (translation: TextConfigurationTranslation): Filter[] => [
  {
    id: filterId.textId,
    label: translation.text_id,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.inputIntegerFilter,
        includeInSummary: true
      }
    ],
    type: FilterType.TEXT_RANGE
  },
  {
    id: filterId.textSet,
    label: translation.text_set,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.code,
        optionsEndpoint: endpoints.textSetAllOptions
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.language,
    label: translation.language,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.code,
        optionsEndpoint: endpoints.languageOptions
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.textCollection,
    label: translation.text_collection,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.code,
        optionsEndpoint: endpoints.textCollectionOptions,
        optionsParams: { displayNotSelected: true }
      }
    ],
    type: FilterType.SELECTED_IDS
  }
];

export const textDefaultFilters = (userLanguage: FilterCommonValues<FilterCommonTypes>, translation: TextConfigurationTranslation): {
  [key: string]: FilterCommonValues<FilterCommonTypes>[];
} => ({
  [getFieldId(filterId.language, fieldType.root)]: [userLanguage]
});
